import React from 'react';
import * as PropTypes from 'prop-types';

class OnClickOutside extends React.PureComponent {
    constructor(props) {
        super(props);
        this.wrapperRef = props.ref || React.createRef();
    }

    handleClick = e => {
        const child = React.Children.only(this.props.children);
        const ref = child.ref || this.wrapperRef;

        if (!ref.current.contains(e.target)) {
            this.props.onClickOutside();
        }
    };

    componentDidMount = () => {
        window.addEventListener('mousedown', this.handleClick);
    };

    componentWillUnmount = () => {
        window.removeEventListener('mousedown', this.handleClick);
    };

    render = () => {
        const child = React.Children.only(this.props.children);

        // The child component might already have a ref. In that case, use it.
        if (child.ref) return child;

        // Else add a ref
        return React.cloneElement(child, {
            ref: this.wrapperRef,
        });
    };
}

OnClickOutside.propTypes = {
    children: PropTypes.element.isRequired,
    onClickOutside: PropTypes.func.isRequired,
    ref: PropTypes.any,
};

export default OnClickOutside;
